import { forwardRef, useImperativeHandle } from 'react';

import cn from 'classnames';
import { useForm } from 'react-hook-form';

import { Button, InputGroup, Select, Textarea } from 'components/FormComponents';

export const CommentBox = forwardRef(
  (
    {
      maxLength = 255,
      onSubmit = () => {},
      onCancel = () => {},
      className = '',
      actionLabel = 'Send',
      cancelLabel = 'Cancel',
      placeholder = 'Type your message...',
      tags = [],
      tagDefault = '',
      value = '',
    },
    ref,
  ) => {
    const {
      register,
      handleSubmit,
      watch,
      formState: { errors },
      reset,
    } = useForm();

    useImperativeHandle(ref, () => ({
      reset,
    }));

    const handleCancel = () => {
      reset();
      onCancel();
    };

    return (
      <div className={cn(className)}>
        <form onSubmit={handleSubmit(onSubmit)} className="d-flex flex-column u-gap u-margin-top">
          <InputGroup title="Tag" className="u-margin-bottom--0">
            <Select
              register={register}
              name="tag"
              value={watch('tag')}
              useDefault
              defaultValue={tagDefault}>
              {tags.map(tag => (
                <Select.Item key={tag.value} value={tag.value}>
                  {tag.name}
                </Select.Item>
              ))}
            </Select>
          </InputGroup>
          <Textarea
            defaultValue={value}
            register={register}
            validators={{ required: true }}
            error={errors?.message?.type}
            name="message"
            placeholder={placeholder}
            inputProps={{ rows: 5, maxLength }}
          />
          <div className="u-flex-align-self-end d-flex u-gap">
            <Button type="secondary" submit small onClick={handleCancel}>
              {cancelLabel}
            </Button>
            <Button submit small>
              {actionLabel}
            </Button>
          </div>
        </form>
      </div>
    );
  },
);
